import { formatNumber, getRemainingTimeTexts, pluralize } from '../../utils/index';
import { useProject } from '../project-hooks/useProject';
import styles from './project-info-box-givers-and-time.module.less';
import { DONOR_TEXT_KEY, DONORS_TEXT_KEY } from '../i18n/project-i18n-model';
import { useI18nTexts } from '../i18n/useI18nTexts';

const RemainingText = ({ generalText, datetime, showDateTimeIfExists }) => {
    return (
        <div>
            <span suppressHydrationWarning>
                {generalText} {showDateTimeIfExists && datetime ? datetime : ''}
            </span>
        </div>
    );
};

const RemainingTime = ({ time, timeText }) => {
    return (
        <span className={styles.remainingTime} suppressHydrationWarning>
            <strong>{time}</strong> {timeText}
        </span>
    );
};

export const ProjectInfoBoxGiversAndTime = ({ showDateTimeWithGeneralText }) => {
    const project = useProject();
    const remainingTimeTexts = getRemainingTimeTexts(project);
    const texts = useI18nTexts([DONORS_TEXT_KEY, DONOR_TEXT_KEY]);

    const giverComponent = !project.refunded_at && (
        <div>
            <strong>{formatNumber(project.giver_count)}</strong>{' '}
            {pluralize(project.giver_count, texts[DONOR_TEXT_KEY], texts[DONORS_TEXT_KEY])}
        </div>
    );

    const timeOrTextComponent = remainingTimeTexts.generalText ? (
        <RemainingText
            generalText={remainingTimeTexts.generalText}
            datetime={remainingTimeTexts.datetime}
            showDateTimeIfExists={showDateTimeWithGeneralText}
        />
    ) : remainingTimeTexts.time && remainingTimeTexts.timeText ? (
        <RemainingTime time={remainingTimeTexts.time} timeText={remainingTimeTexts.timeText} />
    ) : null;

    return (
        <>
            {giverComponent && giverComponent}
            {giverComponent && timeOrTextComponent && <>,&nbsp;</>}
            {timeOrTextComponent && timeOrTextComponent}
        </>
    );
};
